<template>
  <v-snackbar
    :timeout="timeout"
    :color="cor"
    bottom
    v-model="snackbar"
    multi-line
    @input="chamarCallback"
  >
    <span v-html="mensagem"></span>
    <template v-slot:action="{ attrs }">
      <v-btn text @click.native="fechar" :color="corBotao" v-bind="attrs">Fechar</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      snackbar: false,
      mensagem: "",
      cor: "",
      timeout: 3000,
      callback: null,
    };
  },

  methods: {
    exibir(opcoes, callback) {
      this.mensagem = opcoes.mensagem || "";
      this.cor = opcoes.cor || "";
      this.timeout = opcoes.timeout != null ? opcoes.timeout : 3000;
      this.callback = opcoes.callback || null;

      this.snackbar = true;
    },

    fechar() {
      this.snackbar = false;
      this.chamarCallback();
    },

    chamarCallback() {
      if (this.callback != null) {
        this.callback();
      }
    },
  },
  computed: {
    corBotao() {
      return this.cor == "default" || this.cor == "" ? "primary" : "default";
    },
  },
};
</script>

<style></style>
